<template>
  <div class="min-h-screen bg-white relative">
    <!-- Header Component -->
    <SiteHeader 
      :currentSite="'main'" 
      :activeSection="activeSection"
      @toggleMobileMenu="handleToggleMobileMenu"
      @openContactModal="handleOpenContactModal"
      @openLoginModal="handleOpenLoginModal"
      @smoothScrollTo="handleSmoothScrollTo"
    />
    <!-- News Section -->
    <section id="news" class="bg-white">
      <!-- Featured (first 3) - Full Width -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-0">
        <div 
          v-for="item in newsData.slice(0, 3)" 
          :key="item.id" 
          @click="openNewsModal(item)"
          class="group relative cursor-pointer"
        >
<div class="relative aspect-video overflow-hidden">
            <img 
              :src="'https://img.youtube.com/vi/' + item.youtubeId + '/maxresdefault.jpg'" 
              :alt="item.title" 
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            >
            <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <div class="w-16 h-16 bg-red-600/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                <svg class="w-7 h-7 text-white ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
              </div>
            </div>
            <div class="absolute bottom-0 left-0 right-0 p-5">
              <h4 class="font-bold text-white text-lg leading-snug mb-2 drop-shadow-lg line-clamp-2">{{ item.title }}</h4>
              <div class="flex items-center justify-between">
                <span class="text-gray-300 text-sm">{{ item.date }}</span>
                <span class="inline-flex items-center gap-1 bg-black/40 text-white/70 text-xs font-medium px-2 py-0.5 rounded-md tracking-wider">RE-POST : 11/01/2569</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        <div class="text-center mb-10">
          <h3 class="text-3xl font-bold text-gray-900 mb-3">ข่าวสาร</h3>
          <p class="text-lg text-gray-600">กิจกรรมและผลลัพธ์การขับเคลื่อนคลัสเตอร์</p>
        </div>

        <!-- Grid (remaining) -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div 
            v-for="item in newsData.slice(3)" 
            :key="item.id" 
            @click="openNewsModal(item)"
            class="group relative block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow border border-gray-100 cursor-pointer"
          >
<div class="relative aspect-video overflow-hidden">
              <img 
                :src="'https://img.youtube.com/vi/' + item.youtubeId + '/maxresdefault.jpg'" 
                :alt="item.title" 
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              >
              <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                  <svg class="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                </div>
              </div>
            </div>
            <div class="p-4">
              <h4 class="font-bold text-gray-900 text-base leading-snug mb-2 group-hover:text-teal-600 transition-colors line-clamp-2">{{ item.title }}</h4>
              <div class="flex items-center justify-between">
                <span class="text-gray-400 text-sm">{{ item.date }}</span>
                <span class="inline-flex items-center gap-1 bg-gray-200 text-gray-500 text-xs font-medium px-2 py-0.5 rounded-md tracking-wider">RE-POST : 11/01/2569</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Facebook News Grid Section - มะระขี้นก -->
    <section id="fb-news" class="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-10">
          <div class="inline-flex items-center gap-2 bg-blue-50 text-blue-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            Facebook
          </div>
          <h3 class="text-3xl font-bold text-gray-900 mb-3">กิจกรรมมะระขี้นก</h3>
          <p class="text-lg text-gray-600">รวมกิจกรรมและความเคลื่อนไหว Cluster มะระขี้นก จาก Facebook</p>
          <p class="text-sm text-gray-400 mt-2">ทั้งหมด {{ fbReadyPosts.length }} โพสต์</p>
        </div>

        <!-- Category Filter -->
        <div class="flex flex-wrap justify-center gap-2 mb-8">
          <button 
            @click="fbActiveCategory = 'all'"
            :class="fbActiveCategory === 'all' ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            ทั้งหมด ({{ fbReadyPosts.length }})
          </button>
          <button 
            v-for="cat in fbCategories" 
            :key="cat.name"
            @click="fbActiveCategory = cat.name"
            :class="fbActiveCategory === cat.name ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            {{ cat.icon }} {{ cat.name }} ({{ cat.count }})
          </button>
        </div>

        <!-- Loading indicator -->
        <div v-if="fbOgLoading" class="text-center mb-6">
          <div class="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-lg text-sm">
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            กำลังโหลดข้อมูล... ({{ fbOgLoadedCount }}/{{ fbPostsData.length }})
          </div>
        </div>

        <!-- Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          <a 
            v-for="post in filteredFbPosts" 
            :key="post.id" 
            :href="post.url"
            target="_blank"
            rel="noopener noreferrer"
            class="group block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:-translate-y-1"
          >
            <!-- Thumbnail -->
            <div class="relative aspect-video overflow-hidden bg-gray-100">
              <img 
                v-if="post.thumbnail"
                :src="post.thumbnail" 
                :alt="post.title" 
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
                @error="(e) => e.target.style.display = 'none'"
              >
              <!-- Fallback placeholder when no image -->
              <div 
                v-if="!post.thumbnail || post.loading"
                class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100"
              >
                <div v-if="post.loading" class="animate-pulse flex flex-col items-center gap-2">
                  <div class="w-12 h-12 bg-blue-200 rounded-full"></div>
                  <div class="w-24 h-2 bg-blue-200 rounded"></div>
                </div>
                <div v-else class="flex flex-col items-center gap-2">
                  <svg class="w-10 h-10 text-blue-300" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                  <span class="text-xs text-blue-400">Facebook Post</span>
                </div>
              </div>
              <!-- Category badge -->
              <div class="absolute top-2 left-2">
                <span class="inline-flex items-center gap-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1 rounded-lg">
                  {{ getCategoryIcon(post.category) }} {{ post.category }}
                </span>
              </div>
              <!-- Facebook icon -->
              <div class="absolute top-2 right-2">
                <div class="w-7 h-7 bg-blue-600 rounded-full flex items-center justify-center shadow-lg">
                  <svg class="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </div>
              </div>
            </div>
            <!-- Content -->
            <div class="p-4">
              <h4 class="font-semibold text-gray-900 text-sm leading-snug mb-2 group-hover:text-blue-600 transition-colors line-clamp-3">{{ post.title }}</h4>
              <div class="flex items-center justify-between">
                <span class="text-gray-400 text-xs">โพสต์ #{{ post.id }}</span>
                <span class="inline-flex items-center gap-1 text-blue-500 text-xs font-medium group-hover:underline">
                  อ่านเพิ่มเติม
                  <svg class="w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
                </span>
              </div>
            </div>
          </a>
        </div>

        <!-- Show more / less -->
        <div v-if="filteredFbPostsFull.length > fbShowCount" class="text-center mt-8">
          <button 
            @click="fbShowCount = fbShowCount >= filteredFbPostsFull.length ? 12 : filteredFbPostsFull.length"
            class="inline-flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm"
          >
            <template v-if="fbShowCount < filteredFbPostsFull.length">
              แสดงทั้งหมด ({{ filteredFbPostsFull.length }})
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>
            </template>
            <template v-else>
              แสดงน้อยลง
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/></svg>
            </template>
          </button>
        </div>
      </div>
    </section>

    <!-- SIE Press Coverage Section -->
    <section id="sie-press" class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-10">
          <div class="inline-flex items-center gap-2 bg-teal-50 text-teal-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/></svg>
            Press Coverage
          </div>
          <h3 class="text-3xl font-bold text-gray-900 mb-3">สื่อที่เผยแพร่ข่าวสาร Cluster SIE</h3>
          <p class="text-lg text-gray-600">รวมข่าวจากสื่อมวลชน หน่วยงานรัฐ และโซเชียลมีเดีย</p>
          <p class="text-sm text-gray-400 mt-2">ทั้งหมด {{ sieReadyItems.length }} แหล่งข่าว</p>
        </div>

        <!-- Source Type Filter -->
        <div class="flex flex-wrap justify-center gap-2 mb-8">
          <button 
            @click="sieActiveType = 'all'"
            :class="sieActiveType === 'all' ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            ทั้งหมด ({{ sieReadyItems.length }})
          </button>
          <button 
            v-for="st in sieSourceTypes" 
            :key="st.type"
            @click="sieActiveType = st.type"
            :class="sieActiveType === st.type ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            {{ st.icon }} {{ st.label }} ({{ st.count }})
          </button>
        </div>

        <!-- Loading indicator -->
        <div v-if="sieOgLoading" class="text-center mb-6">
          <div class="inline-flex items-center gap-2 bg-teal-50 text-teal-600 px-4 py-2 rounded-lg text-sm">
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            กำลังโหลดข้อมูล... ({{ sieOgLoadedCount }}/{{ siePressItems.length }})
          </div>
        </div>

        <!-- Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          <a 
            v-for="item in filteredSiePress" 
            :key="item.id" 
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
            class="group block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1"
          >
            <!-- Thumbnail -->
            <div class="relative aspect-video overflow-hidden bg-gray-100">
              <img 
                v-if="item.thumbnail"
                :src="item.thumbnail" 
                :alt="item.ogTitle || item.title" 
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
                @error="(e) => e.target.style.display = 'none'"
              >
              <!-- Fallback placeholder -->
              <div 
                v-if="!item.thumbnail || item.loading"
                class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-teal-50 to-emerald-50"
              >
                <div v-if="item.loading" class="animate-pulse flex flex-col items-center gap-2">
                  <div class="w-12 h-12 bg-teal-200 rounded-full"></div>
                  <div class="w-24 h-2 bg-teal-200 rounded"></div>
                </div>
                <div v-else class="flex flex-col items-center gap-2">
                  <span class="text-3xl">{{ getSieTypeIcon(item.type) }}</span>
                  <span class="text-xs text-teal-400">{{ item.source }}</span>
                </div>
              </div>
              <!-- Source badge -->
              <div class="absolute top-2 left-2">
                <span class="inline-flex items-center gap-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1 rounded-lg">
                  {{ getSieTypeIcon(item.type) }} {{ item.source }}
                </span>
              </div>
              <!-- YouTube play button -->
              <div v-if="item.type === 'video'" class="absolute inset-0 flex items-center justify-center">
                <div class="w-14 h-14 bg-red-600/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                  <svg class="w-6 h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                </div>
              </div>
            </div>
            <!-- Content -->
            <div class="p-4">
              <h4 class="font-semibold text-gray-900 text-sm leading-snug mb-2 group-hover:text-teal-600 transition-colors line-clamp-3">{{ item.ogTitle || item.title }}</h4>
              <div class="flex items-center justify-between">
                <span class="text-gray-400 text-xs">{{ item.source }}</span>
                <span class="inline-flex items-center gap-1 text-teal-500 text-xs font-medium group-hover:underline">
                  อ่านเพิ่มเติม
                  <svg class="w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
                </span>
              </div>
            </div>
          </a>
        </div>

        <!-- Show more / less -->
        <div v-if="filteredSiePressFull.length > sieShowCount" class="text-center mt-8">
          <button 
            @click="sieShowCount = sieShowCount >= filteredSiePressFull.length ? 12 : filteredSiePressFull.length"
            class="inline-flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm"
          >
            <template v-if="sieShowCount < filteredSiePressFull.length">
              แสดงทั้งหมด ({{ filteredSiePressFull.length }})
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>
            </template>
            <template v-else>
              แสดงน้อยลง
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/></svg>
            </template>
          </button>
        </div>
      </div>
    </section>

    <!-- สื่อประชาสัมพันธ์งาน SIE Cluster Section -->
    <section id="sie-pr" class="py-16 bg-gradient-to-b from-white to-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-10">
          <div class="inline-flex items-center gap-2 bg-orange-50 text-orange-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"/></svg>
            ประชาสัมพันธ์
          </div>
          <h3 class="text-3xl font-bold text-gray-900 mb-3">สื่อประชาสัมพันธ์งาน SIE Cluster</h3>
          <p class="text-lg text-gray-600">รวมสื่อประชาสัมพันธ์จาก Facebook, YouTube และเว็บไซต์ต่างๆ</p>
          <p class="text-sm text-gray-400 mt-2">ทั้งหมด {{ siePrReadyPosts.length }} โพสต์</p>
        </div>

        <!-- Category Filter -->
        <div class="flex flex-wrap justify-center gap-2 mb-8">
          <button 
            @click="siePrActiveCategory = 'all'"
            :class="siePrActiveCategory === 'all' ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            ทั้งหมด ({{ siePrReadyPosts.length }})
          </button>
          <button 
            v-for="cat in siePrCategories" 
            :key="cat.name"
            @click="siePrActiveCategory = cat.name"
            :class="siePrActiveCategory === cat.name ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            {{ cat.icon }} {{ cat.name }} ({{ cat.count }})
          </button>
        </div>

        <!-- Loading indicator -->
        <div v-if="siePrOgLoading" class="text-center mb-6">
          <div class="inline-flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-lg text-sm">
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            กำลังโหลดข้อมูล... ({{ siePrOgLoadedCount }}/{{ siePrPostsData.length }})
          </div>
        </div>

        <!-- Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          <a 
            v-for="post in filteredSiePrPosts" 
            :key="post.id" 
            :href="post.url"
            target="_blank"
            rel="noopener noreferrer"
            class="group block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-200 hover:-translate-y-1"
          >
            <!-- Thumbnail -->
            <div class="relative aspect-video overflow-hidden bg-gray-100">
              <img 
                v-if="post.thumbnail"
                :src="post.thumbnail" 
                :alt="post.ogTitle || post.title" 
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
                @error="(e) => e.target.style.display = 'none'"
              >
              <!-- Fallback placeholder -->
              <div 
                v-if="!post.thumbnail || post.loading"
                class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-orange-50 to-amber-50"
              >
                <div v-if="post.loading" class="animate-pulse flex flex-col items-center gap-2">
                  <div class="w-12 h-12 bg-orange-200 rounded-full"></div>
                  <div class="w-24 h-2 bg-orange-200 rounded"></div>
                </div>
                <div v-else class="flex flex-col items-center gap-2">
                  <span class="text-3xl">{{ post.source === 'YouTube' ? '📺' : post.source === 'เว็บไซต์' ? '🌐' : '📘' }}</span>
                  <span class="text-xs text-orange-400">{{ post.source }}</span>
                </div>
              </div>
              <!-- Category badge -->
              <div class="absolute top-2 left-2">
                <span class="inline-flex items-center gap-1 bg-black/60 backdrop-blur-sm text-white text-xs font-medium px-2.5 py-1 rounded-lg">
                  {{ getSiePrCategoryIcon(post.category) }} {{ post.category }}
                </span>
              </div>
              <!-- Source icon -->
              <div class="absolute top-2 right-2">
                <div class="w-7 h-7 rounded-full flex items-center justify-center shadow-lg" :class="post.source === 'YouTube' ? 'bg-red-600' : post.source === 'เว็บไซต์' ? 'bg-teal-600' : 'bg-blue-600'">
                  <svg v-if="post.source === 'YouTube'" class="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/><path fill="#fff" d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                  <svg v-else-if="post.source === 'เว็บไซต์'" class="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/></svg>
                  <svg v-else class="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </div>
              </div>
              <!-- YouTube play button -->
              <div v-if="post.source === 'YouTube'" class="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div class="w-12 h-12 bg-red-600/90 rounded-full flex items-center justify-center shadow-lg">
                  <svg class="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                </div>
              </div>
            </div>
            <!-- Content -->
            <div class="p-4">
              <h4 class="font-semibold text-gray-900 text-sm leading-snug mb-2 group-hover:text-orange-600 transition-colors line-clamp-3">{{ post.ogTitle || post.title }}</h4>
              <div class="flex items-center justify-between">
                <span class="text-gray-400 text-xs">{{ post.source }} &bull; {{ post.title }}</span>
                <span class="inline-flex items-center gap-1 text-orange-500 text-xs font-medium group-hover:underline">
                  อ่านเพิ่มเติม
                  <svg class="w-3 h-3 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
                </span>
              </div>
            </div>
          </a>
        </div>

        <!-- Show more / less -->
        <div v-if="filteredSiePrPostsFull.length > siePrShowCount" class="text-center mt-8">
          <button 
            @click="siePrShowCount = siePrShowCount >= filteredSiePrPostsFull.length ? 12 : filteredSiePrPostsFull.length"
            class="inline-flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm"
          >
            <template v-if="siePrShowCount < filteredSiePrPostsFull.length">
              แสดงทั้งหมด ({{ filteredSiePrPostsFull.length }})
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg>
            </template>
            <template v-else>
              แสดงน้อยลง
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"/></svg>
            </template>
          </button>
        </div>
      </div>
    </section>

        <!-- Ebook Section -->
    <section id="ebook" class="py-16 bg-gray-100">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-8">
          <h3 class="text-3xl font-bold text-gray-900 mb-4">📖 E-Book</h3>
          <p class="text-lg text-gray-600">เอกสารและคู่มือเกี่ยวกับโครงการ Cluster SIE</p>
        </div>

        <!-- Cover Card -->
        <div class="flex justify-center">
          <div 
            @click="isEbookModalOpen = true" 
            class="relative cursor-pointer group max-w-sm"
          >
            <div class="relative overflow-hidden rounded-xl shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-[1.02] border border-gray-200">
              <img 
                :src="ebookPages[0]" 
                alt="E-Book Cluster SIE" 
                class="w-full h-auto object-contain"
              >
              <!-- Hover overlay -->
              <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                <span class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white text-gray-900 px-6 py-3 rounded-full font-semibold shadow-lg text-sm">
                  📖 เปิดอ่าน E-Book
                </span>
              </div>
            </div>
            <p class="text-center text-gray-500 text-sm mt-3">คลิกที่ปกเพื่อเปิดอ่าน</p>
          </div>
        </div>
      </div>
    </section>


        <!-- Ebook Modal -->
    <EbookModal 
      :isOpen="isEbookModalOpen" 
      :pages="ebookPages" 
      @close="isEbookModalOpen = false" 
    />

    <!-- Video Section -->
    <section id="video" class="py-12 bg-white">
      <div class="text-center mb-8 px-4">
        <h3 class="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
          SIE <span class="text-teal-600">REAL</span> IMPACT
        </h3>
        <p class="text-gray-500 text-lg tracking-widest mb-1">REAL PEOPLE &bull; REAL PRODUCTS &bull; REAL MARKET</p>
        <p class="text-gray-900 text-xl md:text-2xl font-bold mt-4">PANEL DISCUSSION</p>
        <p class="text-gray-500 text-sm md:text-base mt-2">Social Integrated Enterprise Cluster<br>Initiative for Grassroots Economic Development</p>
      </div>
      <video 
        class="w-full block" 
        controls 
        preload="metadata"
        poster=""
      >
        <source src="https://pub-f9bc77f030934e56b3d143eddfe4b9df.r2.dev/SIE%20%E0%B9%80%E0%B8%AA%E0%B8%A7%E0%B8%99%E0%B8%B2.mp4" type="video/mp4">
      </video>

      <!-- Cluster Activity News Section -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-12">
        <div class="mb-8">
          <h4 class="text-3xl font-bold text-gray-900 mb-3">กิจกรรมและผลลัพธ์การขับเคลื่อนคลัสเตอร์</h4>
          <p class="text-lg text-gray-600">Cluster Activities & Impact</p>
          <p class="text-sm text-gray-400 mt-1">📅 RE-POST วันที่ 10 มกราคม 2569</p>
        </div>

        <div class="space-y-6">
          <div 
            v-for="item in clusterNewsItems" 
            :key="item.id"
            @click="openActivityNewsModal(item)"
            class="group bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg hover:border-teal-400 transition-all duration-300 cursor-pointer"
          >
            <div class="flex flex-col md:flex-row gap-0">
              <!-- Thumbnail (first image) -->
              <div class="relative w-full md:w-72 h-52 md:h-auto flex-shrink-0 bg-gray-100 overflow-hidden">
                <img 
                  :src="item.images[0]" 
                  :alt="item.title"
                  class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                >
                <div class="absolute top-3 left-3 bg-teal-600 text-white text-xs font-bold px-3 py-1 rounded-lg shadow">
                  ฉบับที่ {{ item.id }}
                </div>
                <div v-if="item.images.length > 1" class="absolute bottom-3 right-3 bg-black/60 text-white text-xs font-bold px-2.5 py-1 rounded-lg flex items-center gap-1">
                  <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                  {{ item.images.length }}
                </div>
              </div>

              <!-- Content -->
              <div class="flex-1 p-5 md:p-6 flex flex-col justify-between min-w-0">
                <div>
                  <h5 class="text-lg md:text-xl font-bold text-gray-900 mb-3 leading-snug group-hover:text-teal-600 transition-colors">{{ item.title }}</h5>
                  <p class="text-sm text-gray-600 leading-relaxed line-clamp-4 whitespace-pre-line">{{ item.content }}</p>
                </div>
                <div class="mt-4 flex items-center gap-3">
                  <span class="inline-flex items-center gap-1.5 text-xs font-medium text-teal-600 bg-teal-50 px-3 py-1.5 rounded-lg">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
                    {{ item.images.length }} ภาพประกอบ
                  </span>
                  <span class="text-xs text-gray-400 group-hover:text-teal-500 transition-colors">คลิกเพื่ออ่านเพิ่มเติม →</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-6">
          <span class="text-gray-500 text-sm">ทั้งหมด {{ clusterNewsItems.length }} ข่าว</span>
        </div>
      </div>

      <!-- Highlight Section -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-12">
        <div class="mb-8">
          <h4 class="text-3xl font-bold text-gray-900 mb-3">ไฮไลท์</h4>
          <p class="text-lg text-gray-600">ข่าวเด่นจากกิจกรรมขับเคลื่อนคลัสเตอร์</p>
        </div>

        <div class="space-y-6">
          <div
            v-for="item in highlights"
            :key="item.id"
            @click="openHighlightModal(item)"
            class="group bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg hover:border-amber-400 transition-all duration-300 cursor-pointer"
          >
            <div class="flex flex-col md:flex-row gap-0">
              <!-- Thumbnail -->
              <div class="relative w-full md:w-72 h-52 md:h-auto flex-shrink-0 bg-gray-100 overflow-hidden">
                <img
                  :src="item.images[0]"
                  :alt="item.title"
                  class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                >
                <div class="absolute top-3 left-3 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow">{{ item.badge }}</div>
                <div class="absolute bottom-3 right-3 bg-black/60 text-white text-xs px-2 py-1 rounded-lg">{{ item.images.length }} รูป</div>
              </div>
              <!-- Content -->
              <div class="flex-1 p-5 md:p-6 flex flex-col justify-between min-w-0">
                <div>
                  <div class="flex items-center gap-2 mb-2 flex-wrap">
                    <span class="text-xs font-medium text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full">📅 {{ item.date }}</span>
                    <span v-if="item.category" class="text-xs font-medium text-teal-600 bg-teal-50 px-2 py-0.5 rounded-full">{{ item.categoryIcon }} {{ item.category }}</span>
                    <span class="text-xs text-gray-400">{{ item.references.length }} สื่อรายงาน</span>
                  </div>
                  <h5 class="text-lg md:text-xl font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-amber-600 transition-colors leading-snug">{{ item.title }}</h5>
                  <p class="text-sm text-gray-500 line-clamp-2">{{ item.summary }}</p>
                </div>
                <div class="flex items-center gap-2 mt-4 flex-wrap">
                  <span class="text-xs font-semibold text-amber-700 bg-amber-50 px-3 py-1.5 rounded-lg">อ่านต่อ →</span>
                  <template v-if="item.relatedSections">
                    <a
                      v-for="(sec, sIdx) in item.relatedSections"
                      :key="sIdx"
                      :href="sec.target"
                      @click.stop
                      class="text-xs font-medium text-teal-600 bg-teal-50 hover:bg-teal-100 px-3 py-1.5 rounded-lg transition-colors"
                    >ดู {{ sec.label }}</a>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Highlight Detail Modal -->
      <Teleport to="body">
        <Transition name="news-modal">
          <div v-if="isHighlightModalOpen && selectedHighlight" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeHighlightModal">
            <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="closeHighlightModal"></div>
            <div class="relative w-full max-w-4xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col z-10">
              <button @click="closeHighlightModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>

              <!-- Hero Image -->
              <div class="relative w-full aspect-video bg-gray-100 flex-shrink-0 overflow-hidden cursor-pointer" @click="openHighlightLightbox(0)">
                <img :src="selectedHighlight.images[0]" :alt="selectedHighlight.title" class="w-full h-full object-cover">
                <div class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div class="absolute bottom-4 left-4 bg-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow">{{ selectedHighlight.badge }}</div>
              </div>

              <!-- Scrollable Content -->
              <div class="flex-1 overflow-y-auto p-6 md:p-8">
                <div class="flex items-center gap-2 mb-3">
                  <span class="text-xs font-medium text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full">📅 {{ selectedHighlight.date }}</span>
                </div>
                <h2 class="text-xl md:text-2xl font-bold text-gray-900 mb-4 leading-snug">{{ selectedHighlight.title }}</h2>

                <!-- Article Content -->
                <div class="text-gray-700 leading-relaxed mb-6 text-base space-y-4">
                  <p v-for="(para, idx) in selectedHighlight.content.split('\n\n')" :key="idx">{{ para }}</p>
                </div>

                <!-- Image Gallery Grid -->
                <div class="mb-6">
                  <h6 class="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3">รูปภาพประกอบ</h6>
                  <div class="grid grid-cols-3 gap-2">
                    <div
                      v-for="(img, imgIdx) in selectedHighlight.images"
                      :key="imgIdx"
                      @click.stop="openHighlightLightbox(imgIdx)"
                      class="relative aspect-video bg-gray-100 rounded-lg overflow-hidden cursor-pointer hover:ring-2 hover:ring-amber-400 transition-all"
                    >
                      <img :src="img" :alt="'รูป ' + (imgIdx + 1)" class="w-full h-full object-cover hover:scale-105 transition-transform duration-300" loading="lazy">
                    </div>
                  </div>
                </div>

                <!-- Reference Links (OG enriched) -->
                <div class="border-t border-gray-200 pt-6">
                  <div class="flex items-center justify-between mb-3">
                    <h6 class="text-sm font-bold text-gray-500 uppercase tracking-wider">สื่อที่เผยแพร่ข่าวสาร ({{ highlightRefs.length }})</h6>
                    <div v-if="highlightRefsLoading" class="flex items-center gap-2 text-xs text-amber-600">
                      <div class="w-3.5 h-3.5 border-2 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
                      กำลังโหลด...
                    </div>
                  </div>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <a
                      v-for="(ref, refIdx) in highlightRefs"
                      :key="refIdx"
                      :href="ref.url"
                      target="_blank"
                      rel="noopener"
                      @click.stop
                      class="flex gap-0 bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-md hover:border-amber-300 transition-all duration-200 group"
                    >
                      <!-- OG Thumbnail -->
                      <div class="relative w-28 h-20 flex-shrink-0 bg-gray-100 overflow-hidden">
                        <template v-if="ref.loading">
                          <div class="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse"></div>
                        </template>
                        <template v-else-if="ref.thumbnail">
                          <img :src="ref.thumbnail" :alt="ref.ogTitle" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" @error="$event.target.style.display='none'">
                        </template>
                        <template v-else>
                          <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
                            <span class="text-3xl">{{ ref.url.includes('facebook.com') ? '📘' : '📰' }}</span>
                          </div>
                        </template>
                        <div class="absolute top-1.5 left-1.5 bg-white/90 backdrop-blur-sm text-gray-700 text-[10px] font-bold px-1.5 py-0.5 rounded shadow-sm">{{ ref.siteName || ref.label }}</div>
                      </div>
                      <!-- Content -->
                      <div class="flex-1 py-2 px-3 flex flex-col justify-center min-w-0">
                        <h6 class="text-sm font-bold text-gray-900 line-clamp-1 group-hover:text-amber-600 transition-colors leading-snug">
                          <template v-if="ref.loading"><div class="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div></template>
                          <template v-else>{{ ref.ogTitle || ref.label }}</template>
                        </h6>
                        <p v-if="!ref.loading && ref.description" class="text-xs text-gray-500 line-clamp-1 mt-0.5">{{ ref.description }}</p>
                        <span class="text-[10px] text-gray-400 truncate mt-1">{{ ref.url }}</span>
                      </div>
                      <!-- Arrow -->
                      <div class="flex items-center pr-3 flex-shrink-0">
                        <svg class="w-4 h-4 text-gray-300 group-hover:text-amber-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </Teleport>

      <!-- Highlight Lightbox Modal -->
      <Teleport to="body">
        <Transition name="news-modal">
          <div v-if="isHighlightLightboxOpen" class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/90" @click.self="closeHighlightLightbox">
            <button @click="closeHighlightLightbox" class="absolute top-4 right-4 z-10 w-10 h-10 bg-white/20 hover:bg-white/40 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            <button v-if="highlightLightboxIndex > 0" @click.stop="highlightLightboxIndex--" class="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/40 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
            </button>
            <button v-if="highlightLightboxIndex < highlightLightboxImages.length - 1" @click.stop="highlightLightboxIndex++" class="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/40 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
            </button>
            <img :src="highlightLightboxImages[highlightLightboxIndex]" class="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl">
            <div class="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 text-white text-sm px-4 py-1.5 rounded-full">
              {{ highlightLightboxIndex + 1 }} / {{ highlightLightboxImages.length }}
            </div>
          </div>
        </Transition>
      </Teleport>

      <!-- Activity News Detail Modal -->
      <Teleport to="body">
        <Transition name="news-modal">
          <div v-if="isActivityNewsModalOpen && selectedActivityNews" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeActivityNewsModal">
            <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="closeActivityNewsModal"></div>
            <div class="relative w-full max-w-4xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col z-10">
              <!-- Close Button -->
              <button @click="closeActivityNewsModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>

              <!-- Hero Image -->
              <div class="relative w-full aspect-video bg-gray-100 flex-shrink-0 overflow-hidden cursor-pointer" @click="openActivityLightbox(selectedActivityNews.id, 0)">
                <img 
                  :src="selectedActivityNews.images[0]" 
                  :alt="selectedActivityNews.title"
                  class="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                >
                <div class="absolute top-4 left-4 bg-teal-600 text-white text-sm font-bold px-4 py-1.5 rounded-lg shadow">
                  ฉบับที่ {{ selectedActivityNews.id }}
                </div>
              </div>

              <!-- Scrollable Content -->
              <div class="p-6 md:p-8 overflow-y-auto">
                <h3 class="text-xl md:text-2xl font-bold text-gray-900 mb-4 leading-snug">{{ selectedActivityNews.title }}</h3>
                <div class="text-gray-700 leading-relaxed text-base whitespace-pre-line mb-6">{{ selectedActivityNews.content }}</div>

                <!-- Image Gallery -->
                <div v-if="selectedActivityNews.images.length > 1" class="border-t border-gray-200 pt-6">
                  <h4 class="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4">ภาพประกอบข่าว ({{ selectedActivityNews.images.length }} ภาพ)</h4>
                  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                    <div 
                      v-for="(img, imgIdx) in selectedActivityNews.images" 
                      :key="imgIdx"
                      @click="openActivityLightbox(selectedActivityNews.id, imgIdx)"
                      class="group/img cursor-pointer rounded-xl overflow-hidden aspect-square relative border-2 border-gray-100 hover:border-teal-500 transition-colors"
                    >
                      <img :src="img" :alt="'ภาพ ' + (imgIdx + 1)" class="w-full h-full object-cover group-hover/img:scale-110 transition-transform duration-300" loading="lazy">
                      <div class="absolute inset-0 bg-black/0 group-hover/img:bg-black/20 transition-all flex items-center justify-center">
                        <svg class="w-6 h-6 text-white opacity-0 group-hover/img:opacity-100 transition-opacity" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </Teleport>

      <!-- Activity Lightbox Modal -->
      <Teleport to="body">
        <Transition name="news-modal">
          <div v-if="isActivityLightboxOpen" class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/90" @click.self="closeActivityLightbox">
            <button @click="closeActivityLightbox" class="absolute top-4 right-4 z-20 w-10 h-10 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            <div class="absolute top-4 left-4 text-white/80 text-sm font-medium z-20">
              {{ activityLightboxIndex + 1 }} / {{ activityLightboxImages.length }}
            </div>
            <button v-if="activityLightboxIndex > 0" @click.stop="activityLightboxIndex--" class="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
            </button>
            <img 
              :src="activityLightboxImages[activityLightboxIndex]" 
              :alt="'ภาพกิจกรรม ' + (activityLightboxIndex + 1)" 
              class="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
              @click.stop
            >
            <button v-if="activityLightboxIndex < activityLightboxImages.length - 1" @click.stop="activityLightboxIndex++" class="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
            </button>
          </div>
        </Transition>
      </Teleport>

      <!-- TikTok Influencer Section -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 mb-12">
        <div class="text-center mb-10">
          <div class="inline-flex items-center gap-2 bg-gray-900 text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.43 6.3 6.3 0 001.86-4.48V8.73a8.2 8.2 0 004.78 1.53V6.81a4.84 4.84 0 01-1.06-.12z"/></svg>
            TikTok
          </div>
          <h4 class="text-3xl font-bold text-gray-900 mb-3">Influencer รีวิวงาน SIE Cluster</h4>
          <p class="text-lg text-gray-600">คลิปรีวิวจากอินฟลูเอนเซอร์ชื่อดังบน TikTok</p>
          <p class="text-sm text-gray-400 mt-2">ทั้งหมด {{ tiktokInfluencers.length }} ช่อง &bull; {{ tiktokTotalClips }} คลิป</p>
        </div>

        <!-- Loading indicator -->
        <div v-if="tiktokLoading" class="text-center mb-6">
          <div class="inline-flex items-center gap-2 bg-gray-100 text-gray-600 px-4 py-2 rounded-lg text-sm">
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            กำลังโหลดคลิป TikTok... ({{ tiktokLoadedCount }}/{{ tiktokTotalClips }})
          </div>
        </div>

        <!-- Channel Tabs -->
        <div class="flex flex-wrap justify-center gap-2 mb-8">
          <button 
            @click="tiktokActiveChannel = 'all'"
            :class="tiktokActiveChannel === 'all' ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            ทุกช่อง ({{ tiktokTotalClips }})
          </button>
          <button 
            v-for="inf in tiktokInfluencers" 
            :key="inf.id"
            @click="tiktokActiveChannel = inf.id"
            :class="tiktokActiveChannel === inf.id ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 hover:bg-gray-100'"
            class="px-4 py-2 rounded-full text-sm font-medium transition-all border border-gray-200 shadow-sm"
          >
            {{ inf.avatar }} {{ inf.channel }} ({{ inf.clips.length }})
          </button>
        </div>

        <!-- Grid of TikTok clips (vertical aspect ratio) -->
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          <div 
            v-for="clip in filteredTiktokClips" 
            :key="clip.id"
            @click="openTiktokEmbed(clip)"
            class="group cursor-pointer"
          >
            <div class="relative rounded-xl overflow-hidden bg-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-200 hover:border-gray-400 hover:-translate-y-1"
              style="aspect-ratio: 9/16;"
            >
              <!-- Embedded TikTok player (muted, no autoplay as preview) -->
              <iframe 
                v-if="clip.videoId"
                :src="'https://www.tiktok.com/player/v1/' + clip.videoId + '?music_info=0&description=0&rel=0&autoplay=0'"
                class="w-full h-full pointer-events-none"
                frameborder="0"
                allow="encrypted-media"
                allowfullscreen
                loading="lazy"
              ></iframe>
              <!-- Loading placeholder -->
              <div v-else class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-gray-800 to-gray-900">
                <div class="animate-pulse flex flex-col items-center gap-3">
                  <svg class="w-10 h-10 text-gray-500" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.43 6.3 6.3 0 001.86-4.48V8.73a8.2 8.2 0 004.78 1.53V6.81a4.84 4.84 0 01-1.06-.12z"/></svg>
                  <div class="w-16 h-2 bg-gray-700 rounded"></div>
                </div>
              </div>
              <!-- Play overlay on hover -->
              <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center pointer-events-none">
                <div class="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 scale-75 group-hover:scale-100">
                  <svg class="w-6 h-6 text-gray-900 ml-0.5" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                </div>
              </div>
              <!-- Channel badge -->
              <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 pointer-events-none">
                <p class="text-white text-xs font-bold truncate">{{ clip._channel }}</p>
                <p class="text-gray-300 text-[10px]">{{ clip.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TikTok Embed Modal -->
      <Teleport to="body">
        <Transition name="news-modal">
          <div v-if="isTiktokModalOpen && selectedTiktokClip" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeTiktokModal">
            <div class="absolute inset-0 bg-black/80 backdrop-blur-sm" @click="closeTiktokModal"></div>
            <div class="relative z-10 w-full max-w-sm mx-4">
              <!-- Close Button -->
              <button @click="closeTiktokModal" class="absolute -top-12 right-0 z-20 w-10 h-10 bg-white/20 hover:bg-white/40 text-white rounded-full flex items-center justify-center transition-colors">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>
              <!-- TikTok embed iframe -->
              <div class="rounded-2xl overflow-hidden shadow-2xl bg-black" style="aspect-ratio: 9/16;">
                <iframe 
                  v-if="selectedTiktokClip.videoId"
                  :src="'https://www.tiktok.com/player/v1/' + selectedTiktokClip.videoId + '?music_info=1&description=1&autoplay=1'"
                  class="w-full h-full"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                ></iframe>
              </div>
              <!-- Info below -->
              <div class="mt-3 text-center">
                <p class="text-white font-bold text-sm">{{ selectedTiktokClip._channel }}</p>
                <a :href="selectedTiktokClip.url" target="_blank" rel="noopener" class="inline-flex items-center gap-1 text-gray-400 text-xs hover:text-white transition-colors mt-1">
                  เปิดใน TikTok
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/></svg>
                </a>
              </div>
            </div>
          </div>
        </Transition>
      </Teleport>

      <!-- Press Coverage Section (hidden) -->
      <div v-if="false" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-8">
        <div class="mb-8 flex items-center justify-between flex-wrap gap-4">
          <div>
            <h4 class="text-3xl font-bold text-gray-900 mb-3">กิจกรรมและผลลัพธ์การขับเคลื่อนคลัสเตอร์</h4>
            <p class="text-lg text-gray-600">Cluster Activities & Impact</p>
            <p class="text-sm text-gray-400 mt-1">📅 RE-POST วันที่ 10 มกราคม 2569</p>
          </div>
          <div v-if="ogLoading" class="flex items-center gap-3 bg-teal-50 px-4 py-2 rounded-full">
            <div class="w-5 h-5 border-2 border-teal-600 border-t-transparent rounded-full animate-spin"></div>
            <span class="text-sm font-medium text-teal-700">กำลังโหลด {{ ogLoadedCount }}/{{ pressUrls.length }}...</span>
          </div>
        </div>

        <div class="space-y-4">
          <div 
            v-for="item in relatedVideos" 
            :key="item.id"
            @click="openVideoModal(item)"
            class="group flex gap-0 bg-white rounded-2xl border-2 overflow-hidden hover:shadow-2xl hover:border-teal-500 transition-all duration-300 cursor-pointer"
            :class="item.loading ? 'border-gray-200 animate-pulse' : 'border-gray-300'"
          >
            <!-- Thumbnail (Left) -->
            <div class="relative w-72 h-44 flex-shrink-0 bg-gray-200 overflow-hidden">
              <template v-if="item.loading">
                <div class="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse"></div>
              </template>
              <template v-else-if="item.thumbnail">
                <img 
                  :src="item.thumbnail" 
                  :alt="item.title"
                  class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                  @error="$event.target.style.display='none'"
                >
              </template>
              <template v-else>
                <div class="w-full h-full bg-gradient-to-br from-gray-100 to-gray-300 flex items-center justify-center">
                  <span class="text-5xl">{{ getSourceIcon(item.url) }}</span>
                </div>
              </template>
              <!-- Source badge -->
              <div class="absolute top-3 left-3 bg-white/95 backdrop-blur-sm text-gray-800 text-xs font-bold px-3 py-1.5 rounded-lg shadow-sm">
                {{ item.siteName || getDomain(item.url) }}
              </div>
            </div>

            <!-- Content (Right) -->
            <div class="flex-1 py-5 px-6 flex flex-col justify-between min-w-0">
              <div>
                <h5 class="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-teal-600 transition-colors leading-snug">
                  <template v-if="item.loading">
                    <div class="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                    <div class="h-6 bg-gray-200 rounded w-1/2"></div>
                  </template>
                  <template v-else>
                    {{ item.title }}
                  </template>
                </h5>
                <p v-if="!item.loading && item.description" class="text-sm text-gray-500 line-clamp-2 mb-3">{{ item.description }}</p>
              </div>
              <div class="flex items-center gap-3 flex-wrap">
                <span class="inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-lg" 
                  :class="item.isFacebook ? 'bg-blue-50 text-blue-700' : 'bg-teal-50 text-teal-700'">
                  <span>{{ getSourceIcon(item.url) }}</span>
                  {{ getDomain(item.url) }}
                </span>
                <span class="text-xs text-gray-400 truncate max-w-sm hidden md:inline">{{ item.url }}</span>
              </div>
            </div>

            <!-- Arrow -->
            <div class="flex items-center pr-6 flex-shrink-0">
              <div class="w-10 h-10 rounded-full bg-gray-100 group-hover:bg-teal-100 flex items-center justify-center transition-colors">
                <svg class="w-5 h-5 text-gray-400 group-hover:text-teal-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-8">
          <span class="text-gray-500 text-sm">ทั้งหมด {{ relatedVideos.length }} สื่อ</span>
        </div>
      </div>
    </section>

    <!-- Products Section -->
    <section id="products" class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-3xl font-bold text-gray-900 mb-4">สินค้าจากคลัสเตอร์</h3>
          <p class="text-lg text-gray-600">สินค้าคุณภาพจากเครือข่ายธุรกิจชุมชนทั่วประเทศ</p>
        </div>
        
        <!-- Products by Set: แต่ละ set มี banner ของตัวเอง -->
        <div v-for="set in productSets" :key="set.id" class="mb-10">
          <!-- Set Banner: รูปบน ข้อความล่าง -->
          <div class="mb-4 rounded-xl overflow-hidden shadow-md border border-gray-200">
            <div class="relative">
              <img :src="set.banner.image" :alt="set.banner.title" class="w-full h-auto object-contain">
              <div class="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            <div class="bg-gradient-to-r from-teal-600 to-cyan-700 px-5 py-3 flex items-center gap-4">
              <div class="flex-1 flex flex-wrap items-center gap-x-4 gap-y-1">
                <span class="bg-white/20 text-white text-[10px] font-semibold px-2.5 py-0.5 rounded-full">📅 {{ set.banner.date }}</span>
                <h3 class="text-base md:text-lg font-bold text-white">{{ set.banner.title }}</h3>
                <span class="bg-white/20 text-white text-[10px] font-semibold px-2.5 py-0.5 rounded-full">{{ set.label }}</span>
                <p class="text-teal-50 text-xs hidden md:inline">{{ set.banner.description }}</p>
              </div>
              <a :href="set.banner.lineUrl" target="_blank" class="flex-shrink-0 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-semibold text-xs transition-all duration-200 shadow hover:shadow-md">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/></svg>
                สั่งซื้อผ่าน LINE
              </a>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div 
              v-for="product in set.products" 
              :key="product.id" 
              class="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg hover:border-green-200 transition-all duration-200"
            >
            <!-- Product Code + Price Header -->
            <div class="flex items-center justify-between px-3 py-1.5 bg-gray-50 border-b border-gray-100">
              <span class="text-xs font-bold text-gray-700">{{ product.code }}</span>
              <span v-if="product.badge" class="text-[10px] font-bold text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded">{{ product.badge }}</span>
            </div>
            
            <!-- Product Info -->
            <div class="p-3">
              <h4 class="text-sm font-bold text-gray-900 mb-1 leading-snug line-clamp-2">{{ product.name }}</h4>
              <p class="text-gray-400 text-xs mb-2 leading-relaxed line-clamp-2">{{ product.description }}</p>
              
              <!-- Highlights -->
              <div v-if="product.highlights" class="flex flex-wrap gap-1 mb-2">
                <span 
                  v-for="tag in product.highlights" 
                  :key="tag" 
                  class="px-1.5 py-0.5 bg-teal-50 text-teal-600 text-[10px] font-medium rounded"
                >
                  {{ tag }}
                </span>
              </div>
              
              <!-- Price & Action -->
              <div class="flex items-center justify-between pt-2 border-t border-gray-100">
                <div>
                  <span class="text-green-600 font-bold text-base">{{ formatPrice(product.price) }}</span>
                  <span class="text-gray-400 text-[10px]">/{{ product.unit }}</span>
                </div>
                <button class="bg-green-600 hover:bg-green-700 text-white px-2.5 py-1 rounded text-xs font-semibold transition-colors">
                  สั่งซื้อ
                </button>
              </div>
            </div>
            </div>
          </div>
        </div>

        <!-- Contact CTA -->
        <div class="text-center mt-10">
          <div class="inline-flex flex-col sm:flex-row items-center gap-3 bg-gray-50 rounded-2xl px-8 py-5 border border-gray-200">
            <span class="text-gray-600">สนใจสินค้า? แจ้งรหัสสินค้าและจำนวนผ่าน LINE ได้เลย</span>
            <a href="#" target="_blank" class="bg-green-500 hover:bg-green-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm transition-colors inline-flex items-center gap-2">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314"/></svg>
              ติดต่อ LINE
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Articles Section -->
    <section id="articles" class="py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-3xl font-bold text-gray-900 mb-4">บทความล่าสุด</h3>
          <p class="text-lg text-gray-600">ข่าวสารและความรู้เกี่ยวกับการพัฒนาคลัสเตอร์และเศรษฐกิจหมุนเวียน</p>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <article v-for="article in articlesData" :key="article.id" class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
            <img :src="article.image" :alt="article.imageAlt" class="w-full h-auto object-contain">
            <div class="p-6">
              <div :class="categoryColorMap[article.categoryColor] || 'text-green-600'" class="text-sm font-medium mb-2">{{ article.category }}</div>
              <h4 class="text-xl font-semibold text-gray-900 mb-3">{{ article.title }}</h4>
              <p class="text-gray-600 mb-4">{{ article.description }}</p>
              <div class="flex justify-between items-center">
                <span class="text-gray-500 text-sm">{{ article.date }}</span>
                <button @click="openArticleModal(article)" class="text-green-600 hover:text-green-700 text-sm font-medium cursor-pointer bg-transparent border-none">อ่านต่อ →</button>
              </div>
            </div>
          </article>
        </div>

        <div class="text-center mt-8">
          <button class="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors">
            ดูความรู้ทั้งหมด
          </button>
        </div>
      </div>
    </section>


    <!-- News Detail Modal -->
    <Teleport to="body">
      <Transition name="news-modal">
        <div v-if="isNewsModalOpen && selectedNews" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeNewsModal">
          <!-- Backdrop -->
          <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="closeNewsModal"></div>
          
          <!-- Modal Content -->
          <div class="relative w-full max-w-4xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col z-10">
            <!-- Close Button -->
            <button @click="closeNewsModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            
            <!-- YouTube Video Embed -->
            <div class="relative w-full aspect-video bg-black flex-shrink-0">
              <iframe 
                :src="'https://www.youtube.com/embed/' + selectedNews.youtubeId + '?autoplay=1&rel=0'" 
                class="absolute inset-0 w-full h-full" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen
              ></iframe>
            </div>
            
            <!-- Content -->
            <div class="p-6 overflow-y-auto">
              <h2 class="text-xl md:text-2xl font-bold text-gray-900 mb-3 leading-snug">{{ selectedNews.title }}</h2>
              <div class="flex items-center gap-4 mb-4">
                <span class="text-sm text-gray-500">📅 {{ selectedNews.date }}</span>
                <a :href="selectedNews.youtube" target="_blank" rel="noopener" class="inline-flex items-center gap-1.5 text-sm text-red-600 hover:text-red-700 font-medium">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                  ดูบน YouTube
                </a>
              </div>
              <p class="text-gray-600 leading-relaxed">{{ selectedNews.description }}</p>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- Article Detail Modal -->
    <ArticleDetailModal 
      :isOpen="isArticleModalOpen" 
      :article="selectedArticle" 
      @close="closeArticleModal" 
    />

    <!-- Press Article Detail Modal -->
    <Teleport to="body">
      <Transition name="news-modal">
        <div v-if="isVideoModalOpen && selectedVideo" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeVideoModal">
          <!-- Backdrop -->
          <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="closeVideoModal"></div>
          
          <!-- Modal Content -->
          <div class="relative w-full max-w-4xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col z-10">
            <!-- Close Button -->
            <button @click="closeVideoModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            
            <!-- OG Image -->
            <div class="relative w-full bg-gray-100 flex-shrink-0" style="max-height: 50vh;">
              <img 
                v-if="selectedVideo.thumbnail" 
                :src="selectedVideo.thumbnail" 
                :alt="selectedVideo.title"
                class="w-full h-full object-contain"
                style="max-height: 50vh;"
              >
              <div v-else class="w-full h-64 bg-gradient-to-br from-teal-50 to-cyan-100 flex items-center justify-center">
                <span class="text-8xl">{{ getSourceIcon(selectedVideo.url) }}</span>
              </div>
            </div>
            
            <!-- Content -->
            <div class="p-8 overflow-y-auto">
              <div class="flex items-center gap-3 mb-4">
                <span class="inline-flex items-center gap-2 text-sm font-bold px-3 py-1.5 rounded-lg"
                  :class="selectedVideo.isFacebook ? 'bg-blue-100 text-blue-700' : 'bg-teal-100 text-teal-700'">
                  <span>{{ getSourceIcon(selectedVideo.url) }}</span>
                  {{ selectedVideo.siteName || getDomain(selectedVideo.url) }}
                </span>
              </div>
              <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mb-4 leading-snug">ไทย–ซาอุฯ จับมือครั้งสำคัญ สมาพันธ์เอสเอ็มอีไทย ลงนาม MOU กับสภาธุรกิจซาอุดีอาระเบีย–ไทย เปิดประตู SME ไทยสู่ตลาดซาอุดีอาระเบีย</h2>
              
              <!-- Full article content -->
              <div class="text-gray-700 leading-relaxed mb-6 text-base space-y-4">
                <p v-for="(para, idx) in pressArticleContent.split('\n\n')" :key="idx">{{ para }}</p>
              </div>

              <!-- Hashtags -->
              <div class="flex flex-wrap gap-2 mb-6">
                <span v-for="tag in pressHashtags.split(' ')" :key="tag" class="text-xs font-medium text-teal-600 bg-teal-50 px-2 py-1 rounded-full">{{ tag }}</span>
              </div>
              
              <div class="flex items-center gap-4 flex-wrap border-t pt-6">
                <a :href="selectedVideo.url" target="_blank" rel="noopener" class="inline-flex items-center gap-2 text-base font-semibold px-6 py-3 rounded-lg transition-colors"
                  :class="selectedVideo.isFacebook ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-teal-600 hover:bg-teal-700 text-white'">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                  </svg>
                  อ่านต้นฉบับที่ {{ selectedVideo.siteName || getDomain(selectedVideo.url) }}
                </a>
                <span class="text-sm text-gray-400 truncate max-w-md">{{ selectedVideo.url }}</span>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>


      <!-- Activities Gallery Section -->
    <section id="gallery" class="py-16 bg-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-4xl font-bold text-gray-900 mb-4">SIE Insights</h3>
          <p class="text-lg text-gray-600">ศูนย์ข้อมูลและอินโฟกราฟิก</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          <div 
            v-for="(img, idx) in galleryImages" 
            :key="idx" 
            @click="openGalleryModal(idx)"
            class="group cursor-pointer overflow-hidden rounded-xl aspect-square relative"
          >
            <img 
              :src="img" 
              :alt="'กิจกรรม ' + (idx + 1)" 
              class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              loading="lazy"
            >
            <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
              <svg class="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Gallery Lightbox Modal -->
    <Teleport to="body">
      <Transition name="news-modal">
        <div v-if="isGalleryModalOpen" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90" @click.self="closeGalleryModal">
          <button @click="closeGalleryModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-white/20 hover:bg-white/30 text-white rounded-full flex items-center justify-center transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
          <div class="absolute top-4 left-4 text-white/80 text-sm font-medium z-20">
            {{ galleryActiveIndex + 1 }} / {{ galleryImages.length }}
          </div>
          <button v-if="galleryActiveIndex > 0" @click.stop="galleryActiveIndex--" class="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
          </button>
          <img 
            :src="galleryImages[galleryActiveIndex]" 
            :alt="'กิจกรรม ' + (galleryActiveIndex + 1)" 
            class="max-w-[90vw] max-h-[85vh] object-contain rounded-lg shadow-2xl"
            @click.stop
          >
          <button v-if="galleryActiveIndex < galleryImages.length - 1" @click.stop="galleryActiveIndex++" class="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white/10 hover:bg-white/20 text-white rounded-full flex items-center justify-center transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
          </button>
        </div>
      </Transition>
    </Teleport>

    <!-- Footer Component -->
    <SiteFooter />
  </div>
</template>

<script setup>
import SiteHeader from '~/layouts/theme/custom/clustersie/components/SiteHeader.vue'
import SiteFooter from '~/layouts/theme/custom/clustersie/components/SiteFooter.vue'
import SiteSelector from '~/layouts/theme/custom/clustersie/components/SiteSelector.vue'
import MobileMenu from '~/layouts/theme/custom/clustersie/components/MobileMenu.vue'
import CountdownTimer from '~/layouts/theme/custom/clustersie/components/CountdownTimer.vue'
import NotifyForm from '~/layouts/theme/custom/clustersie/components/NotifyForm.vue'
import SocialLinks from '~/layouts/theme/custom/clustersie/components/SocialLinks.vue'
import ArticleDetailModal from '~/layouts/theme/custom/clustersie/components/ArticleDetailModal.vue'
import EbookModal from '~/layouts/theme/custom/clustersie/components/EbookModal.vue'
import { articlesData, categoryColorMap } from '~/layouts/theme/custom/clustersie/sites/data/articlesData.js'
import { productSets, formatPrice } from '~/layouts/theme/custom/clustersie/sites/data/productsData.js'
import { newsData } from '~/layouts/theme/custom/clustersie/sites/data/newsData.js'
import { clusterActivityImages, newsItems as clusterNewsItems } from '~/layouts/theme/custom/clustersie/sites/data/clusterActivityData.js'
import { highlights } from '~/layouts/theme/custom/clustersie/sites/data/highlightData.js'
import { fbPostsData as fbPostsDataRaw, fbCategoryConfig } from '~/layouts/theme/custom/clustersie/sites/data/fbPostsData.js'
import { siePressData as siePressDataRaw, sieSourceTypeConfig } from '~/layouts/theme/custom/clustersie/sites/data/siePressData.js'
import { tiktokInfluencers as tiktokInfluencersRaw } from '~/layouts/theme/custom/clustersie/sites/data/tiktokInfluencerData.js'
import { siePrPostsData as siePrPostsDataRaw, siePrCategoryConfig } from '~/layouts/theme/custom/clustersie/sites/data/siePrPostsData.js'
import { onMounted, onUnmounted, ref, nextTick, computed } from 'vue'
import { useNuxtApp } from '#app'

// Define props to receive theme data from parent
const props = defineProps({
  theme: {
    type: Object,
    default: () => ({})
  }
})

// Mobile menu state
const isMobileMenuOpen = ref(false)
const activeSection = ref('home')

// Contact modal state
const isContactModalOpen = ref(false)

// Login modal state  
const isLoginModalOpen = ref(false)

// News detail modal state
const isNewsModalOpen = ref(false)
const selectedNews = ref(null)

// Article detail modal state
const isArticleModalOpen = ref(false)
const selectedArticle = ref(null)

// Video detail modal state
const isVideoModalOpen = ref(false)
const selectedVideo = ref(null)

// Ebook state
const isEbookModalOpen = ref(false)
const ebookPages = ref([
  'https://iili.io/qFRxgvn.jpg',
  'https://iili.io/qFRxUYX.jpg',
  'https://iili.io/qFRxS2t.jpg',
  'https://iili.io/qFRxv4I.jpg',
  'https://iili.io/qFRxkEN.jpg',
  'https://iili.io/qFRxeBp.jpg',
  'https://iili.io/qFRxNQR.jpg',
  'https://iili.io/qFRxwhv.jpg',
  'https://iili.io/qFRxjTJ.jpg',
  'https://iili.io/qFRxXpa.jpg',
  'https://iili.io/qFRxWkg.jpg',
  'https://iili.io/qFRxVYF.jpg',
  'https://iili.io/qFRxM21.jpg',
  'https://iili.io/qFRx1EB.jpg',
  'https://iili.io/qFRx0BV.jpg',
  'https://iili.io/qFRxcLQ.jpg',
  'https://iili.io/qFRxahx.jpg',
  'https://iili.io/qFRxYIj.jpg',
  'https://iili.io/qFRx5mb.jpg',
  'https://iili.io/qFRxRku.jpg',
  'https://iili.io/qFRxA7e.jpg',
  'https://iili.io/qFRxu29.jpg',
  'https://iili.io/qFRxIr7.jpg',
  'https://iili.io/qFRxz1S.jpg',
  'https://iili.io/qFRxxB2.jpg',
  'https://iili.io/qFRxCX4.jpg',
  'https://iili.io/qFRxBIf.jpg',
  'https://iili.io/qFRxKes.jpg',
  'https://iili.io/qFRxfmG.jpg',
])

// ===== Facebook Posts (มะระขี้นก) =====
const fbPostsData = ref(fbPostsDataRaw.map(p => ({ ...p, thumbnail: '', loading: true })))
const fbOgLoading = ref(true)
const fbOgLoadedCount = ref(0)
const fbActiveCategory = ref('all')
const fbShowCount = ref(12)

// Only show items that are ready (has thumbnail or still loading)
const fbReadyPosts = computed(() => {
  return fbPostsData.value.filter(p => p.loading || p.thumbnail)
})

// Compute unique categories with counts (only ready items)
const fbCategories = computed(() => {
  const map = {}
  fbReadyPosts.value.forEach(p => {
    if (!map[p.category]) {
      const cfg = fbCategoryConfig[p.category] || { icon: '📌' }
      map[p.category] = { name: p.category, icon: cfg.icon, count: 0 }
    }
    map[p.category].count++
  })
  return Object.values(map).sort((a, b) => b.count - a.count)
})

// Filtered posts (full list, only ready)
const filteredFbPostsFull = computed(() => {
  if (fbActiveCategory.value === 'all') return fbReadyPosts.value
  return fbReadyPosts.value.filter(p => p.category === fbActiveCategory.value)
})

// Filtered posts (with show limit)
const filteredFbPosts = computed(() => {
  return filteredFbPostsFull.value.slice(0, fbShowCount.value)
})

const getCategoryIcon = (category) => {
  return (fbCategoryConfig[category] || {}).icon || '📌'
}

// Fetch OG data for Facebook posts
const fetchFbOGData = async () => {
  fbOgLoading.value = true
  fbOgLoadedCount.value = 0

  const batchSize = 4
  for (let i = 0; i < fbPostsDataRaw.length; i += batchSize) {
    const batch = fbPostsDataRaw.slice(i, i + batchSize)
    const promises = batch.map(async (post, batchIdx) => {
      const idx = i + batchIdx
      try {
        const response = await $fetch('/api/og', { query: { url: post.url } })
        if (response.success && response.data && response.data.image) {
          fbPostsData.value[idx] = {
            ...fbPostsData.value[idx],
            thumbnail: response.data.image,
            loading: false,
          }
        } else {
          fbPostsData.value[idx].loading = false
        }
      } catch (err) {
        console.warn(`Failed to fetch FB OG for post #${post.id}:`, err.message)
        fbPostsData.value[idx].loading = false
      }
      fbOgLoadedCount.value++
    })
    await Promise.all(promises)
  }
  fbOgLoading.value = false
}

// ===== SIE PR Posts (สื่อประชาสัมพันธ์) =====
const siePrPostsData = ref(siePrPostsDataRaw.map(p => ({ ...p, thumbnail: '', ogTitle: '', loading: true })))
const siePrOgLoading = ref(true)
const siePrOgLoadedCount = ref(0)
const siePrActiveCategory = ref('all')
const siePrShowCount = ref(12)

// Only show items that are ready (has thumbnail or still loading)
const siePrReadyPosts = computed(() => {
  return siePrPostsData.value.filter(p => p.loading || p.thumbnail)
})

// Compute unique categories with counts (only ready items)
const siePrCategories = computed(() => {
  const map = {}
  siePrReadyPosts.value.forEach(p => {
    if (!map[p.category]) {
      const cfg = siePrCategoryConfig[p.category] || { icon: '📌' }
      map[p.category] = { name: p.category, icon: cfg.icon, count: 0 }
    }
    map[p.category].count++
  })
  // Sort in defined order: ก่อนเริ่มงาน → ช่วงจัดงาน → หลังจัดงาน
  const order = ['ก่อนเริ่มงาน', 'ช่วงจัดงาน', 'หลังจัดงาน']
  return Object.values(map).sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name))
})

const filteredSiePrPostsFull = computed(() => {
  if (siePrActiveCategory.value === 'all') return siePrReadyPosts.value
  return siePrReadyPosts.value.filter(p => p.category === siePrActiveCategory.value)
})

const filteredSiePrPosts = computed(() => {
  return filteredSiePrPostsFull.value.slice(0, siePrShowCount.value)
})

const getSiePrCategoryIcon = (category) => {
  return (siePrCategoryConfig[category] || {}).icon || '📌'
}

const fetchSiePrOGData = async () => {
  siePrOgLoading.value = true
  siePrOgLoadedCount.value = 0

  const batchSize = 4
  for (let i = 0; i < siePrPostsDataRaw.length; i += batchSize) {
    const batch = siePrPostsDataRaw.slice(i, i + batchSize)
    const promises = batch.map(async (post, batchIdx) => {
      const idx = i + batchIdx
      try {
        // YouTube: use thumbnail directly
        const ytPatterns = [
          /youtu\.be\/([^?&#]+)/,
          /youtube\.com\/watch\?v=([^&#]+)/,
        ]
        for (const pat of ytPatterns) {
          const m = post.url.match(pat)
          if (m) {
            siePrPostsData.value[idx] = {
              ...siePrPostsData.value[idx],
              thumbnail: 'https://img.youtube.com/vi/' + m[1] + '/hqdefault.jpg',
              loading: false,
            }
            siePrOgLoadedCount.value++
            return
          }
        }

        const response = await $fetch('/api/og', { query: { url: post.url } })
        if (response.success && response.data) {
          siePrPostsData.value[idx] = {
            ...siePrPostsData.value[idx],
            thumbnail: response.data.image || '',
            ogTitle: response.data.title || '',
            loading: false,
          }
        } else {
          siePrPostsData.value[idx].loading = false
        }
      } catch (err) {
        console.warn(`Failed to fetch OG for SIE PR post #${post.id}:`, err.message)
        siePrPostsData.value[idx].loading = false
      }
      siePrOgLoadedCount.value++
    })
    await Promise.all(promises)
  }
  siePrOgLoading.value = false
}

// ===== SIE Press Coverage =====
const siePressItems = ref(siePressDataRaw.map(p => ({ ...p, thumbnail: '', ogTitle: '', loading: true })))
const sieOgLoading = ref(true)
const sieOgLoadedCount = ref(0)
const sieActiveType = ref('all')
const sieShowCount = ref(12)

// Only show items that are ready (has thumbnail or still loading)
const sieReadyItems = computed(() => {
  return siePressItems.value.filter(p => p.loading || p.thumbnail)
})

// Compute unique source types with counts (only ready items)
const sieSourceTypes = computed(() => {
  const map = {}
  sieReadyItems.value.forEach(p => {
    if (!map[p.type]) {
      const cfg = sieSourceTypeConfig[p.type] || { label: p.type, icon: '📄' }
      map[p.type] = { type: p.type, label: cfg.label, icon: cfg.icon, count: 0 }
    }
    map[p.type].count++
  })
  return Object.values(map).sort((a, b) => b.count - a.count)
})

const filteredSiePressFull = computed(() => {
  if (sieActiveType.value === 'all') return sieReadyItems.value
  return sieReadyItems.value.filter(p => p.type === sieActiveType.value)
})

const filteredSiePress = computed(() => {
  return filteredSiePressFull.value.slice(0, sieShowCount.value)
})

const getSieTypeIcon = (type) => {
  return (sieSourceTypeConfig[type] || {}).icon || '📄'
}

// Helper: get YouTube thumbnail from URL
const getYouTubeThumbnail = (url) => {
  const patterns = [
    /youtu\.be\/([^?&#]+)/,
    /youtube\.com\/watch\?v=([^&#]+)/,
    /youtube\.com\/embed\/([^?&#]+)/,
  ]
  for (const pat of patterns) {
    const m = url.match(pat)
    if (m) return 'https://img.youtube.com/vi/' + m[1] + '/hqdefault.jpg'
  }
  return null
}

const fetchSieOGData = async () => {
  sieOgLoading.value = true
  sieOgLoadedCount.value = 0

  const batchSize = 4
  for (let i = 0; i < siePressDataRaw.length; i += batchSize) {
    const batch = siePressDataRaw.slice(i, i + batchSize)
    const promises = batch.map(async (item, batchIdx) => {
      const idx = i + batchIdx
      try {
        // YouTube: use thumbnail directly, no OG needed
        const ytThumb = getYouTubeThumbnail(item.url)
        if (ytThumb) {
          siePressItems.value[idx] = {
            ...siePressItems.value[idx],
            thumbnail: ytThumb,
            loading: false,
          }
          sieOgLoadedCount.value++
          return
        }

        const response = await $fetch('/api/og', { query: { url: item.url } })
        if (response.success && response.data) {
          siePressItems.value[idx] = {
            ...siePressItems.value[idx],
            thumbnail: response.data.image || '',
            ogTitle: response.data.title || '',
            loading: false,
          }
        } else {
          siePressItems.value[idx].loading = false
        }
      } catch (err) {
        console.warn(`Failed to fetch OG for SIE press #${item.id}:`, err.message)
        siePressItems.value[idx].loading = false
      }
      sieOgLoadedCount.value++
    })
    await Promise.all(promises)
  }
  sieOgLoading.value = false
}

// ===== TikTok Influencers =====
const tiktokInfluencers = ref(JSON.parse(JSON.stringify(tiktokInfluencersRaw)))
const tiktokLoading = ref(true)
const tiktokLoadedCount = ref(0)
const tiktokActiveChannel = ref('all')
const isTiktokModalOpen = ref(false)
const selectedTiktokClip = ref(null)

const tiktokTotalClips = computed(() => {
  return tiktokInfluencers.value.reduce((sum, inf) => sum + inf.clips.length, 0)
})

// Flatten all clips with channel info for grid display
const allTiktokClips = computed(() => {
  const clips = []
  tiktokInfluencers.value.forEach(inf => {
    inf.clips.forEach(clip => {
      clips.push({ ...clip, _channel: inf.channel, _avatar: inf.avatar })
    })
  })
  return clips
})

const filteredTiktokClips = computed(() => {
  if (tiktokActiveChannel.value === 'all') return allTiktokClips.value
  return allTiktokClips.value.filter(c => {
    const inf = tiktokInfluencers.value.find(i => i.clips.some(cl => cl.id === c.id))
    return inf && inf.id === tiktokActiveChannel.value
  })
})

const openTiktokEmbed = (clip) => {
  if (!clip.videoId) return
  selectedTiktokClip.value = clip
  isTiktokModalOpen.value = true
}

const closeTiktokModal = () => {
  isTiktokModalOpen.value = false
  selectedTiktokClip.value = null
}

const fetchTiktokVideoIds = async () => {
  tiktokLoading.value = true
  tiktokLoadedCount.value = 0

  const batchSize = 3
  for (const inf of tiktokInfluencers.value) {
    for (let i = 0; i < inf.clips.length; i += batchSize) {
      const batch = inf.clips.slice(i, i + batchSize)
      const promises = batch.map(async (clip, batchIdx) => {
        const clipIdx = i + batchIdx
        try {
          const response = await $fetch('/api/tiktok-oembed', { query: { url: clip.url } })
          if (response.success && response.data && response.data.videoId) {
            inf.clips[clipIdx].videoId = response.data.videoId
            if (response.data.title) inf.clips[clipIdx].title = response.data.title
          }
        } catch (err) {
          console.warn(`Failed to resolve TikTok clip #${clip.id}:`, err.message)
        }
        tiktokLoadedCount.value++
      })
      await Promise.all(promises)
    }
  }
  // Trigger reactivity update
  tiktokInfluencers.value = [...tiktokInfluencers.value]
  tiktokLoading.value = false
}

// Gallery - hardcoded R2 images (no API, no dependencies)
const galleryImages = ref([
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398893_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398894_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398895_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398896_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398897_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398898_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398899_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398900_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398901_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398902_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398903_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398904_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398905_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398906_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398907_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398908_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398909_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398910_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398911_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398912_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398914_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398915_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398916_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398917(1).jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398918_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398919_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398920_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398921_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398922_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398923_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398924_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398925_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398926_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398927_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398928_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398929_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398930_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398931_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398932_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398933_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398934_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398935_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398936_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398937_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398938_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398939_0.jpg',
])
const isGalleryModalOpen = ref(false)
const galleryActiveIndex = ref(0)

// Activity Lightbox state
const isActivityLightboxOpen = ref(false)
const activityLightboxImages = ref([])
const activityLightboxIndex = ref(0)

// Activity News Modal state
const isActivityNewsModalOpen = ref(false)
const selectedActivityNews = ref(null)

const openActivityNewsModal = (item) => {
  selectedActivityNews.value = item
  isActivityNewsModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeActivityNewsModal = () => {
  isActivityNewsModalOpen.value = false
  selectedActivityNews.value = null
  document.body.style.overflow = ''
}

const openActivityLightbox = (newsId, imgIdx) => {
  const item = clusterNewsItems.find(n => n.id === newsId)
  if (item) {
    activityLightboxImages.value = item.images
    activityLightboxIndex.value = imgIdx
    isActivityLightboxOpen.value = true
    document.body.style.overflow = 'hidden'
  }
}

const closeActivityLightbox = () => {
  isActivityLightboxOpen.value = false
  activityLightboxImages.value = []
  document.body.style.overflow = ''
}

// Highlight modal state
const isHighlightModalOpen = ref(false)
const selectedHighlight = ref(null)
const isHighlightLightboxOpen = ref(false)
const highlightLightboxImages = ref([])
const highlightLightboxIndex = ref(0)
const highlightRefs = ref([])
const highlightRefsLoading = ref(false)

const openHighlightModal = async (item) => {
  selectedHighlight.value = item
  isHighlightModalOpen.value = true
  document.body.style.overflow = 'hidden'

  // Initialize refs with placeholder
  highlightRefs.value = item.references.map(r => ({
    ...r,
    ogTitle: r.label,
    description: '',
    thumbnail: '',
    siteName: '',
    loading: true,
  }))
  highlightRefsLoading.value = true

  // Fetch OG data in batches
  const batchSize = 5
  for (let i = 0; i < item.references.length; i += batchSize) {
    const batch = item.references.slice(i, i + batchSize)
    const promises = batch.map(async (ref, batchIdx) => {
      const idx = i + batchIdx
      try {
        const response = await $fetch('/api/og', { query: { url: ref.url } })
        if (response.success && response.data) {
          highlightRefs.value[idx] = {
            ...highlightRefs.value[idx],
            ogTitle: response.data.title || ref.label,
            description: response.data.description || '',
            thumbnail: response.data.image || '',
            siteName: response.data.siteName || getDomain(ref.url),
            loading: false,
          }
        } else {
          highlightRefs.value[idx].loading = false
        }
      } catch (err) {
        console.warn(`Failed to fetch OG for ${ref.url}:`, err.message)
        highlightRefs.value[idx].loading = false
      }
    })
    await Promise.all(promises)
  }
  highlightRefsLoading.value = false
}

const closeHighlightModal = () => {
  isHighlightModalOpen.value = false
  selectedHighlight.value = null
  document.body.style.overflow = ''
}

const openHighlightLightbox = (imgIdx) => {
  if (selectedHighlight.value) {
    highlightLightboxImages.value = selectedHighlight.value.images
    highlightLightboxIndex.value = imgIdx
    isHighlightLightboxOpen.value = true
  }
}

const closeHighlightLightbox = () => {
  isHighlightLightboxOpen.value = false
  highlightLightboxImages.value = []
}

// Full article content for MOU press coverage
const pressArticleContent = `ไทย–ซาอุฯ จับมือครั้งสำคัญ สมาพันธ์เอสเอ็มอีไทย ลงนาม MOU กับสภาธุรกิจซาอุดีอาระเบีย–ไทย เปิดประตู SME ไทยสู่ตลาดซาอุดีอาระเบีย ผ่าน "คลัสเตอร์ SIE" รับโอกาส Vision 2030

เมื่อวันศุกร์ที่ 9 มกราคม 2569 ณ ชั้น 19 อาคารเกษรทาวเวอร์ ถนนราชดำริ กรุงเทพมหานคร สภาธุรกิจซาอุดีอาระเบีย–ไทย และสมาพันธ์เอสเอ็มอีไทย ได้ร่วมลงนามบันทึกข้อตกลงความร่วมมือ (MOU) เชิงยุทธศาสตร์ เพื่อเสริมสร้างความร่วมมือด้านการค้าและการลงทุน และเปิดโอกาสใหม่ให้ผู้ประกอบการ SME ไทยสามารถเข้าสู่ตลาดราชอาณาจักรซาอุดีอาระเบียได้อย่างเป็นรูปธรรม ภายใต้โครงการ "คลัสเตอร์ SIE (Social Integrated Enterprise)"

ความร่วมมือครั้งนี้เกิดขึ้นระหว่าง สภาธุรกิจซาอุดีอาระเบีย–ไทย (Saudi–Thai Business Council) ซึ่งเป็นกลไกสำคัญภายใต้สหพันธ์หอการค้าซาอุดีอาระเบีย และสมาพันธ์เอสเอ็มอีไทย (Federation of Thai SMEs) นำโดย ดร.ณพพงศ์ ธีระวร ประธานสมาพันธ์เอสเอ็มอีไทย โดยมีเป้าหมายเพื่อขับเคลื่อนความร่วมมือทางเศรษฐกิจ และยกระดับศักยภาพ SME ไทยให้สามารถแข่งขันในตลาดนานาชาติได้อย่างยั่งยืน

พิธีลงนามได้รับเกียรติจากผู้แทนระดับสูงของทั้งสองฝ่ายเข้าร่วม อาทิ ประธานสมาพันธ์เอสเอ็มอีไทย และประธานสภาธุรกิจซาอุดีอาระเบีย–ไทย สะท้อนถึงความมุ่งมั่นร่วมกันในการสนับสนุนผู้ประกอบการ SME และส่งเสริมการเติบโตของการค้าและการลงทุนระหว่างสองประเทศ

Mr. Osama Kokandy ประธานสภาธุรกิจซาอุดีอาระเบีย–ไทย กล่าวว่า การลงนาม MOU ครั้งนี้ไม่ใช่เพียงข้อตกลงอย่างเป็นทางการ แต่เป็นจุดเริ่มต้นของความร่วมมือระยะยาวบนพื้นฐานของความเคารพ เป้าหมายร่วม และความมุ่งมั่นในการยกระดับความสัมพันธ์ทางเศรษฐกิจระหว่างสองประเทศ โดยธุรกิจไทยมีจุดแข็งด้านคุณภาพ มาตรฐานการทำงาน และความยืดหยุ่น ซึ่งเหมาะสมอย่างยิ่งต่อการเป็นพันธมิตรทางการค้าในตลาดโลก

ด้าน ดร.ณพพงศ์ ธีระวร กล่าวว่า ความร่วมมือในครั้งนี้สะท้อนบทบาทของสมาพันธ์เอสเอ็มอีไทยในการผลักดัน SME ไทยให้ก้าวสู่เวทีนานาชาติ ผ่านการพัฒนาเชิงระบบ การสร้างเครือข่าย และการเชื่อมโยงกับตลาดที่มีศักยภาพสูง โดยซาอุดีอาระเบียถือเป็นหนึ่งในตลาดยุทธศาสตร์สำคัญภายใต้นโยบาย Vision 2030

ขณะที่ คุณสมประสงค์ พยัคฆพันธ์ รองประธานสมาพันธ์เอสเอ็มอีไทย และหัวหน้าโครงการสร้างเครือข่ายธุรกิจชุมชนร่วม (Cluster) กล่าวว่า โครงการคลัสเตอร์ SIE มีที่มาจากงานวิจัยภายใต้โครงการสร้างเครือข่ายธุรกิจชุมชนร่วม (Cluster) เพื่อพัฒนาเศรษฐกิจฐานราก ซึ่งได้รับการสนับสนุนทุนจากหน่วยบริหารและจัดการทุนด้านการพัฒนาระดับพื้นที่ (บพท.) โดยออกแบบให้ SIE เป็นกลไกที่เชื่อมโยงงานวิจัย องค์ความรู้ และภาคธุรกิจ เพื่อยกระดับ SME ไทยให้สามารถรวมกลุ่ม สร้างมาตรฐาน และขยายสู่ตลาดต่างประเทศได้อย่างยั่งยืน

ความร่วมมือภายใต้ MOU ฉบับนี้ จะก่อให้เกิดประโยชน์อย่างเป็นรูปธรรมแก่สมาชิกของทั้งสองฝ่าย ทั้งด้านการเข้าถึงตลาด การจับคู่ธุรกิจ การสนับสนุนด้านกฎระเบียบ การพัฒนาองค์ความรู้ และการส่งเสริมการลงทุนในสาขาสำคัญ เช่น อาหารและเครื่องดื่ม สุขภาพ โลจิสติกส์ การผลิต บริการดิจิทัล และการท่องเที่ยว

การลงนามครั้งนี้จึงถือเป็นอีกหนึ่งก้าวสำคัญในการตอกย้ำบทบาทของสภาธุรกิจซาอุดีอาระเบีย–ไทย และสมาพันธ์เอสเอ็มอีไทย ในฐานะกลไกหลักในการเชื่อมโยงเศรษฐกิจ สนับสนุน SME ซึ่งเป็นแรงขับเคลื่อนสำคัญของนวัตกรรมและการสร้างงาน พร้อมปูทางสู่ความร่วมมือเชิงลึกและยั่งยืนระหว่างสองประเทศในอนาคต`

const pressHashtags = '#clusterSIE #คลัสเตอร์SIE #คลัสเตอร์เอสไออี #การค้าต่างประเทศ #ExportThailand #จับคู่ธุรกิจ #BusinessMatching #SMEStrong #ThaiProduct #การลงทุนระหว่างประเทศ #SaudiArabiaThailand #ThaiSMEs #EconomicCooperation #BusinessSynergy #SaudiVision2030 #GlobalMarket #TradeAgreement'

// Press coverage URLs
const pressUrls = [
  'https://www.banmuang.co.th/news/social/461768',
  'https://siamrath.co.th/press-release/122483',
  'https://www.innnews.co.th/news/news-general/news_988649/',
  'https://mgronline.com/business/detail/9690000003342',
  'https://www.naewna.com/lady/940135',
  'https://mthai.com/news/pr/404959.html',
  'https://www.vateekhao.com/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://www.leadertoday.net/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://www.stageonleader.com/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://www.leadershipway.net/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://weeklypressreport.blogspot.com/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://thereformmedia.blogspot.com/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://ferringgood.blogspot.com/2026/01/mou-saudithai-business-council-9-2569.html',
  'https://khaokrungthep.wordpress.com/2026/01/11/%e0%b8%aa%e0%b8%a1%e0%b8%b2%e0%b8%9e%e0%b8%b1%e0%b8%99%e0%b8%98%e0%b9%8c%e0%b9%80%e0%b8%ad%e0%b8%aa%e0%b9%80%e0%b8%ad%e0%b9%87%e0%b8%a1%e0%b8%ad%e0%b8%b5%e0%b9%84%e0%b8%97%e0%b8%a2-%e0%b8%88%e0%b8%b1/',
]

// Related articles with OG data
const relatedVideos = ref([])
const ogLoading = ref(true)
const ogLoadedCount = ref(0)

// Extract domain from URL
const getDomain = (url) => {
  try {
    return new URL(url).hostname.replace('www.', '')
  } catch {
    return url
  }
}

// Determine source type icon
const getSourceIcon = (url) => {
  if (url.includes('facebook.com')) return '📘'
  if (url.includes('youtube.com')) return '📺'
  return '📰'
}

// Fetch OG data for all URLs
const fetchAllOGData = async () => {
  ogLoading.value = true
  ogLoadedCount.value = 0
  
  // Initialize with placeholder data
  relatedVideos.value = pressUrls.map((url, index) => ({
    id: index + 1,
    title: getDomain(url),
    description: '',
    thumbnail: '',
    siteName: getDomain(url),
    url: url,
    loading: true,
    isFacebook: url.includes('facebook.com'),
  }))

  // Fetch OG in batches of 5 to avoid overwhelming server
  const batchSize = 5
  for (let i = 0; i < pressUrls.length; i += batchSize) {
    const batch = pressUrls.slice(i, i + batchSize)
    const promises = batch.map(async (url, batchIdx) => {
      const idx = i + batchIdx
      try {
        const response = await $fetch('/api/og', { query: { url } })
        if (response.success && response.data) {
          relatedVideos.value[idx] = {
            ...relatedVideos.value[idx],
            title: response.data.title || getDomain(url),
            description: response.data.description || '',
            thumbnail: response.data.image || '',
            siteName: response.data.siteName || getDomain(url),
            loading: false,
          }
        } else {
          relatedVideos.value[idx].loading = false
        }
      } catch (err) {
        console.warn(`Failed to fetch OG for ${url}:`, err.message)
        relatedVideos.value[idx].loading = false
      }
      ogLoadedCount.value++
    })
    await Promise.all(promises)
  }
  
  ogLoading.value = false
}

const openGalleryModal = (idx) => {
  galleryActiveIndex.value = idx
  isGalleryModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeGalleryModal = () => {
  isGalleryModalOpen.value = false
  document.body.style.overflow = ''
}

const openNewsModal = (item) => {
  selectedNews.value = item
  isNewsModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeNewsModal = () => {
  isNewsModalOpen.value = false
  selectedNews.value = null
  document.body.style.overflow = ''
}

const openArticleModal = (article) => {
  selectedArticle.value = article
  isArticleModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeArticleModal = () => {
  isArticleModalOpen.value = false
  selectedArticle.value = null
  document.body.style.overflow = ''
}

const openVideoModal = (video) => {
  selectedVideo.value = video
  isVideoModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeVideoModal = () => {
  isVideoModalOpen.value = false
  selectedVideo.value = null
  document.body.style.overflow = ''
}

// Slider state
const currentSlideIndex = ref(0)
const totalSlides = 3
let slideInterval = null

// Clusters data
const { $DSS } = useNuxtApp()
const clusters = ref([])
const clustersLoading = ref(true)

// Cluster mapping with URLs and icons
const clusterConfig = {
  'กาแฟ': {
    url: 'https://coffee.clustersie.org',
    icon: '☕',
    gradient: 'from-amber-100 to-orange-100',
    name: 'คลัสเตอร์กาแฟ',
    description: 'ระบบจัดการธุรกิจกาแฟครบวงจร',
    colors: {
      primary: 'amber',
      secondary: 'orange'
    }
  },
  'ประมง': {
    url: 'https://fisheries.clustersie.org',
    icon: '🐟',
    gradient: 'from-blue-100 to-cyan-100',
    name: 'คลัสเตอร์ประมง',
    description: 'ระบบจัดการธุรกิจประมงครบวงจร',
    colors: {
      primary: 'blue',
      secondary: 'cyan'
    }
  },
  'ผลไม้': {
    url: 'https://fruit.clustersie.org',
    icon: '🍎',
    gradient: 'from-orange-100 to-yellow-100',
    name: 'คลัสเตอร์ผลไม้',
    description: 'ระบบจัดการธุรกิจผลไม้ครบวงจร',
    colors: {
      primary: 'orange',
      secondary: 'yellow'
    }
  },
  'มะระ': {
    url: 'https://bittermelon.clustersie.org',
    icon: '🥒',
    gradient: 'from-emerald-100 to-green-100',
    name: 'คลัสเตอร์มะระ',
    description: 'ระบบจัดการธุรกิจมะระครบวงจร',
    colors: {
      primary: 'emerald',
      secondary: 'green'
    }
  },
  'ฮาลาล': {
    url: 'https://halal.clustersie.org',
    icon: '🌙',
    gradient: 'from-emerald-100 to-teal-100',
    name: 'คลัสเตอร์ฮาลาล',
    description: 'ระบบจัดการธุรกิจฮาลาลครบวงจร',
    colors: {
      primary: 'emerald',
      secondary: 'teal'
    }
  },
  'หม่อน': {
    url: 'https://mulberry.clustersie.org',
    icon: '🍇',
    gradient: 'from-purple-100 to-pink-100',
    name: 'คลัสเตอร์หม่อน',
    description: 'ระบบจัดการธุรกิจหม่อนครบวงจร',
    colors: {
      primary: 'purple',
      secondary: 'pink'
    }
  }
}

// Fetch clusters data from API
const fetchClusters = async () => {
  try {
    clustersLoading.value = true
    const response = await $DSS('clusters')
    
    if (response && response.success && Array.isArray(response.data)) {
      clusters.value = response.data
      console.log('Fetched clusters:', clusters.value)
    } else {
      console.error('Failed to fetch clusters:', response)
    }
  } catch (error) {
    console.error('Error fetching clusters:', error)
  } finally {
    clustersLoading.value = false
  }
}

// Helper function to format currency
const formatCurrency = (amount) => {
  if (!amount) return '฿0'
  
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  
  if (numAmount >= 1000000) {
    return `฿${(numAmount / 1000000).toFixed(1)}M`
  } else if (numAmount >= 1000) {
    return `฿${(numAmount / 1000).toFixed(0)}K`
  }
  return `฿${numAmount.toLocaleString()}`
}

// Helper function to format number
const formatNumber = (num) => {
  if (!num) return '0'
  return num.toLocaleString()
}

// Get cluster config by name
const getClusterConfig = (clusterName) => {
  // Try exact match first
  if (clusterConfig[clusterName]) {
    return clusterConfig[clusterName]
  }
  
  // Try partial match
  for (const [key, config] of Object.entries(clusterConfig)) {
    if (clusterName.includes(key) || key.includes(clusterName)) {
      return config
    }
  }
  
  // Default config
  return {
    url: '#',
    icon: '📦',
    gradient: 'from-gray-100 to-gray-200',
    name: clusterName,
    description: 'ระบบจัดการธุรกิจครบวงจร',
    colors: {
      primary: 'gray',
      secondary: 'gray'
    }
  }
}

// Log received theme for debugging
console.log('MainSite received theme:', props.theme)

// Handle events from header component
const handleToggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const handleOpenContactModal = () => {
  isContactModalOpen.value = true
}

const handleOpenLoginModal = () => {
  isLoginModalOpen.value = true
}

const handleSmoothScrollTo = (target, event) => {
  smoothScrollTo(target, event)
}

// Slider methods
const showSlide = (index) => {
  currentSlideIndex.value = index
  currentSlide = index
  
  // Update DOM classes
  const slides = document.querySelectorAll('.slide')
  const dots = document.querySelectorAll('.dot')
  
  slides.forEach((slide, i) => {
    if (i === index) {
      slide.classList.add('active')
    } else {
      slide.classList.remove('active')
    }
  })
}

const handleNextSlide = () => {
  const nextIndex = (currentSlideIndex.value + 1) % totalSlides
  showSlide(nextIndex)
  resetAutoSlide()
}

const handlePrevSlide = () => {
  const prevIndex = (currentSlideIndex.value - 1 + totalSlides) % totalSlides
  showSlide(prevIndex)
  resetAutoSlide()
}

const goToSlide = (index) => {
  showSlide(index)
  resetAutoSlide()
}

const startAutoSlide = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
  }
  slideInterval = setInterval(() => {
    handleNextSlide()
  }, 5000)
}

const stopAutoSlide = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
    slideInterval = null
  }
}

const resetAutoSlide = () => {
  stopAutoSlide()
  startAutoSlide()
}

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
}

// Contact modal functions
const openContactModal = () => {
  isContactModalOpen.value = true
  closeMobileMenu()
}

const closeContactModal = () => {
  isContactModalOpen.value = false
}

// Fast smooth scroll function without delays
const smoothScrollTo = (targetId, event) => {
  event?.preventDefault()
  
  // Close mobile menu immediately if open
  closeMobileMenu()
  
  // Handle home section - scroll to top
  if (targetId === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }
  
  // Handle other sections
  const target = document.getElementById(targetId)
  if (!target) {
    return
  }
  
  // Calculate offset for sticky header
  const headerHeight = 80
  const targetPosition = target.offsetTop - headerHeight
  
  // Use native smooth scroll for immediate response
  window.scrollTo({ 
    top: targetPosition, 
    behavior: 'smooth' 
  })
}



// Scroll detection for active section only
const handleScroll = () => {
  const currentScrollY = window.scrollY
  const sections = ['home', 'dashboard', 'clusters', 'products', 'articles', 'gallery', 'contact']
  const scrollPos = currentScrollY + 100 // offset for sticky header

  // Check if we're at the top of the page (home section)
  if (currentScrollY < 50) {
    activeSection.value = 'home'
    return
  }

  // Find active section based on scroll position
  for (let i = sections.length - 1; i >= 0; i--) {
    if (sections[i] === 'home') continue // Skip home as we handle it above
    
    const section = document.getElementById(sections[i])
    if (section && section.offsetTop <= scrollPos) {
      activeSection.value = sections[i]
      break
    }
  }
}

onMounted(() => {
  console.log('MainSite component mounted')
  
  // Fetch clusters data
  fetchClusters()
  
  // Fetch OG data for press coverage
  fetchAllOGData()
  
  // Fetch OG data for Facebook posts
  fetchFbOGData()
  
  // Fetch OG data for SIE press coverage
  fetchSieOGData()

  // Fetch OG data for SIE PR posts
  fetchSiePrOGData()

  // Fetch TikTok video IDs via oEmbed
  fetchTiktokVideoIds()
  
  // Initialize slider with Vue reactive state
  nextTick(() => {
    // Set initial slide
    showSlide(0)
    
    // Start auto slide
    startAutoSlide()
    
    console.log('Slider initialized with Vue reactivity')
  })
  
  // Add scroll listener
  window.addEventListener('scroll', handleScroll)
  
  // Initial check
  handleScroll()
  
  onUnmounted(() => {
    console.log('MainSite component unmounting')
    
    // Stop auto slide
    stopAutoSlide()
    
    // Remove scroll listener
    window.removeEventListener('scroll', handleScroll)
    
    console.log('MainSite cleanup completed')
  })
})
</script>

<style scoped>
/* Main site specific styles */
.bg-gradient-to-br {
  background: linear-gradient(to bottom right, #f0fdf4, #eff6ff);
}

/* Slider Styles */
.slide-container {
  position: relative;
  height: 32rem; /* 128 in Tailwind - increased from 24rem */
  overflow: hidden;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide.active {
  opacity: 1;
  transform: translateX(0);
}

.slide img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.dot {
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot:hover {
  opacity: 80% !important;
  transform: scale(1.2);
}

.dot.active {
  opacity: 100% !important;
  transform: scale(1.3);
}

/* Navigation buttons */
button[id$="Btn"] {
  backdrop-filter: blur(4px);
}

button[id$="Btn"]:hover {
  backdrop-filter: blur(8px);
  transform: scale(1.1);
}

/* Mobile Menu Animations */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: all 0.3s ease-in-out;
}

.mobile-menu-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Mobile menu items */
.mobile-menu-item {
  transition: all 0.2s ease-in-out;
}

.mobile-menu-item:hover {
  transform: translateX(4px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .slide h2 {
    font-size: 2.5rem;
  }
  
  .slide p {
    font-size: 1rem;
  }
  
  /* Hide desktop menu items on mobile */
  .desktop-menu {
    display: none;
  }
}

@media (max-width: 640px) {
  .slide h2 {
    font-size: 2rem;
  }
  
  .slide p {
    font-size: 0.875rem;
  }
  
  /* Adjust mobile menu for smaller screens */
  .mobile-menu-panel {
    max-height: 70vh;
    overflow-y: auto;
  }
}

/* Smooth scroll for one-page navigation */
html {
  scroll-behavior: smooth;
}

/* Adjust scroll position for fixed header */
section {
  scroll-margin-top: 80px;
}

/* Network animation */
@keyframes networkPulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.2);
  }
}

@keyframes connectionFlow {
  0% {
    stroke-dasharray: 5, 5;
    stroke-dashoffset: 10;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes networkConnectFlow {
  0% {
    stroke-dashoffset: 10;
    opacity: 0.1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    stroke-dashoffset: 0;
    opacity: 0.1;
  }
}

@keyframes centralPulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.8;
  }
}

.network-node {
  filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.5));
}

.network-line {
  animation: connectionFlow 2s linear infinite;
}

.connection-line {
  animation: networkConnectFlow 4s ease-in-out infinite;
  filter: drop-shadow(0 0 2px rgba(165, 214, 167, 0.3));
}

.central-connection {
  animation: centralPulse 3s ease-in-out infinite;
  filter: drop-shadow(0 0 3px rgba(129, 199, 132, 0.4));
}

/* Solar System specific styles */
.solar-sun {
  filter: drop-shadow(0 0 6px rgba(255, 213, 79, 0.4));
}

.inner-orbit circle {
  filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.3));
}

.middle-orbit circle {
  filter: drop-shadow(0 0 3px rgba(255, 152, 0, 0.25));
}

.outer-orbit circle {
  filter: drop-shadow(0 0 4px rgba(255, 87, 34, 0.2));
}

.asteroid-belt circle {
  filter: drop-shadow(0 0 1px rgba(189, 189, 189, 0.15));
}

/* News Modal Transition */
.news-modal-enter-active,
.news-modal-leave-active {
  transition: opacity 0.3s ease;
}
.news-modal-enter-active .relative {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.news-modal-leave-active .relative {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.news-modal-enter-from,
.news-modal-leave-to {
  opacity: 0;
}
.news-modal-enter-from .relative {
  transform: scale(0.95) translateY(20px);
  opacity: 0;
}
.news-modal-leave-to .relative {
  transform: scale(0.95) translateY(20px);
  opacity: 0;
}



</style>

<style>
/* Global styles for smooth scroll and fixed navigation */
html {
  scroll-behavior: smooth !important;
}

/* Ensure navigation works globally */
body {
  overflow-x: hidden;
  position: relative;
}

/* Fixed navigation that transforms on scroll */
.nav-fixed {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
}

.nav-fixed.visible {
  transform: translateY(0);
}

/* Original navigation position */
.nav-relative {
  position: relative !important;
  z-index: 999 !important;
}
</style>